import { useUpdateMultiBuyListQueryInCache } from './updateMultiBuyListQueryInCache'
import { useProductsLocaleText } from '../../locale'
import { useMutation } from '@moonpig/web-core-graphql'
import {
  RemoveFromMultiBuyListMutation,
  RemoveFromMultiBuyListMutationVariables,
} from './__generated__/removeFromMultiBuyListGQL'
import { RemoveFromMultiBuyListGQL } from './removeFromMultiBuyListGQL'
import { logger } from '@moonpig/web-core-monitoring'
import {
  RemoveFromMultiBuyListErrorType,
  RemoveFromMultiBuyListResult,
} from './types'

export const useRemoveFromMultiBuyList = () => {
  const { updateAfterRemoveFromMultiBuyList } =
    useUpdateMultiBuyListQueryInCache()
  const localiseText = useProductsLocaleText()

  const [removeFromMultiBuyListMutation, { loading }] = useMutation<
    RemoveFromMultiBuyListMutation,
    RemoveFromMultiBuyListMutationVariables
  >(RemoveFromMultiBuyListGQL, {
    errorPolicy: 'all',
    update: updateAfterRemoveFromMultiBuyList,
  })

  const removeFromMultiBuyList = async (
    multiBuyListItemId: string,
  ): Promise<RemoveFromMultiBuyListResult> => {
    try {
      const { data, errors } = await removeFromMultiBuyListMutation({
        variables: { input: { multiBuyListItemId } },
      })

      const result = data?.removeFromMultiBuyList

      if (
        !result ||
        errors ||
        result.__typename !== 'RemoveFromMultiBuyListSuccess'
      ) {
        logger.fixToday('Failed to remove product from multi buy list', {
          multiBuyListItemId,
          message:
            errors?.map(e => e.message).join(', ') ||
            (result?.__typename === 'RemoveFromMultiBuyListError'
              ? result.message
              : ''),
        })
        return {
          error: {
            errorType: RemoveFromMultiBuyListErrorType.GENERIC,
            errorMessage: localiseText('multi_buy_list.error_try_again'),
          },
        }
      }

      return {}
    } catch (error) {
      logger.fixToday('Failed to remove product from multi buy list', {
        multiBuyListItemId,
        message: error,
      })
      return {
        error: {
          errorType: RemoveFromMultiBuyListErrorType.UNKNOWN,
          errorMessage: localiseText('multi_buy_list.error_try_again'),
        },
      }
    }
  }

  return { removeFromMultiBuyList, loading }
}
